import { selector } from 'recoil';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';
import { allCoverablesToCoverableDTOArray } from '../../utils/coverablesUtil';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { getSortedCoverables } from '../../pages/ShoppingBasketPage/utils/ShoppingBasketUtil';

export const sortedCoverablesListSelector = selector<{
    sortedCoverables: CoverableDTO[];
    sortedRemovedCoverables: CoverableDTO[];
}>({
    key: 'sortedCoverablesListSelector',
    get: ({ get }) => {
        const allCoverables = get(allCoverablesAtom);
        const coverableList = allCoverablesToCoverableDTOArray(allCoverables);
        return getSortedCoverables(coverableList);
    }
});
